import { z } from 'zod';
import { EDITABLE_ITC_STATUSES } from '../enums';
import { isValidGstin } from '../gstin';
import { emptyAsNull, emptyAsUndefined, optionalText, ymd } from './common';

const vendorGstin = z.preprocess(
  (v) => (typeof v === 'string' ? (v.trim() === '' ? null : v.trim().toUpperCase()) : v),
  z.string().refine(isValidGstin, 'Invalid GSTIN (format or checksum)').nullish(),
);

/** Invoice / vendor / ITC fields shared by marketing and other expenses. */
export const invoiceFields = {
  invoiceNumber: optionalText(100),
  invoiceDate: emptyAsNull(ymd),
  vendorName: optionalText(200),
  vendorGstin,
  /** Empty = default (eligible when there is GST). */
  itcStatus: emptyAsUndefined(z.enum(EDITABLE_ITC_STATUSES)),
  notes: optionalText(5000),
};
